import React from 'react';
const Hero = () => {
  return <div className="relative bg-gradient-to-r from-teal-900 via-teal-800 to-teal-900 text-white overflow-hidden" data-id="element-110" data-mp="3q74ir5ghnnxr">
      {/* Background pattern */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-111" data-mp="9kjxsrx55a59">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1614935151651-0bea6508db6b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center opacity-20" data-id="element-112" data-mp="9l341bdfia3g"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-teal-900/70" data-id="element-113" data-mp="128pixfs3x15m"></div>
        {/* Floating circles decoration */}
        <div className="absolute top-20 right-20 w-64 h-64 rounded-full bg-teal-400/10 blur-3xl" data-id="element-114" data-mp="sb1a5lxo1t4g"></div>
        <div className="absolute bottom-10 left-10 w-80 h-80 rounded-full bg-teal-500/10 blur-3xl" data-id="element-115" data-mp="ncgjoe87unt7"></div>
      </div>
      {/* Content */}
      <div className="relative container mx-auto px-4 py-28 md:py-36 max-w-7xl" data-id="element-116" data-mp="3d2bidl8y6rtf">
        <div className="flex flex-col md:flex-row items-center" data-id="element-117" data-mp="3825wklpczzj9">
          <div className="md:w-3/5 md:pr-12 mb-12 md:mb-0" data-id="element-118" data-mp="3j8ix6zga0gup">
            <div className="max-w-xl" data-id="element-119" data-mp="3j924lm8avmuh">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-120" data-mp="3o7lvm11r3otp">
                Science-Backed Microbiome Solutions
              </h1>
              <p className="text-xl mb-8 text-teal-100 leading-relaxed" data-id="element-121" data-mp="39a36gxl5v9lq">
                Transforming cutting-edge research into trusted supplements,
                protocols, and consumer-ready solutions for optimal gut health.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-122" data-mp="3599iy5bmrwtd">
                <button className="bg-white text-teal-800 hover:bg-teal-50 transition-all duration-300 px-6 py-3 rounded-md font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1" data-id="element-123" data-mp="35a2hij0frg0f">
                  Discover Our Products
                </button>
                <button className="bg-transparent border-2 border-white text-white hover:bg-white/10 transition-all duration-300 px-6 py-3 rounded-md font-medium transform hover:-translate-y-1" data-id="element-124" data-mp="2hix4eblvr1tt">
                  Learn More
                </button>
              </div>
            </div>
          </div>
          <div className="md:w-2/5 flex justify-center" data-id="element-125" data-mp="nb1o3ec0ka16">
            <div className="relative w-full max-w-xs" data-id="element-126" data-mp="n9i7fmmg3wyv">
              {/* Decorative elements */}
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-teal-400/30 rounded-full blur-md" data-id="element-127" data-mp="i9vp4yrrfqj7"></div>
              <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-teal-500/30 rounded-full blur-md" data-id="element-128" data-mp="1b0vv3f9nj4di"></div>
              {/* Main image */}
              <div className="relative bg-gradient-to-br from-teal-100/90 to-white/90 p-2 rounded-2xl shadow-2xl" data-id="element-129" data-mp="16346au4azydj">
                <img src="https://images.unsplash.com/photo-1576086213369-97a306d36557?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Microbiome research" className="rounded-xl w-full h-auto object-cover" data-id="element-130" data-mp="11151rgwtuvf0" />
                <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-xl shadow-lg" data-id="element-131" data-mp="3hqk9uf1wzmrs">
                  <div className="text-teal-800 font-bold" data-id="element-132" data-mp="1xacj1d51o1xz">
                    Ukweli Certified™
                  </div>
                  <div className="text-xs text-gray-600" data-id="element-133" data-mp="21b647yr3r2n6">
                    Science-backed formulas
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Hero;